export default __webpack_public_path__ + "static/process-04-d3c8baa7dfecc0f2d7533f58b3be4425.svg";